import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Typography } from "@mui/material";

export default function Modal({ open, handleClose, data }) {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth={"lg"}>
      <DialogTitle
        variant="h5"
        fontWeight={800}
        fontFamily={"M PLUS 1, sans-serif"}
      >
        {data.projectName}
      </DialogTitle>
      <DialogContent dividers={"paper"}>
        <DialogContentText
          sx={{
            display: "flex",
            gap: "20px",
            flexDirection: { xs: "column-reverse", lg: "row" },
          }}
        >
          <Box
            fontFamily={"M PLUS 1, sans-serif"}
            sx={{
              display: "flex",
              width: "100%",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Box>
              <Typography variant="subtitle1" color={"#000"} fontWeight={700}>
                Background
              </Typography>
              <Typography variant="subtitle2" fontWeight={400}>
                {data?.projectDetails?.background}
              </Typography>
            </Box>
            <Box>
              <Typography variant="subtitle1" color={"#000"} fontWeight={700}>
                Problem
              </Typography>
              <Typography variant="subtitle2" fontWeight={400}>
                {data?.projectDetails?.problem}
              </Typography>
            </Box>
            <Box>
              <Typography variant="subtitle1" color={"#000"} fontWeight={700}>
                Description
              </Typography>
              <Typography variant="subtitle2" fontWeight={400}>
                {data?.projectDetails?.description}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              alignSelf: "center",
              width: { sm: "60%", lg: "75%" },
              height: { xs: "250px", sm: "350px", lg: "500px" },
            }}
          >
            <img
              src={data.projectImages[0]}
              alt="Projects"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        {/* <Button onClick={handleClose}>View Project</Button> */}
      </DialogActions>
    </Dialog>
  );
}
